module.exports = __webpack_public_path__ + "img/edit-profile-pic.4405e7c9.svg";